var _desc, _defs, _g, _g2, _g3, _g4, _polyline, _polygon, _polyline2, _polyline3, _polyline4, _polygon2, _polygon3, _polygon4, _polyline5, _path, _path2, _path3, _path4, _path5, _path6, _polygon5, _path7, _path8, _path9, _path10, _path11, _path12, _g5, _g6, _g7, _path13, _path14, _path15, _path16;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUix(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "218px",
    height: "229px",
    viewBox: "0 0 218 229",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "74608B39-20C3-4F28-BE08-E5A91555E5F0") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with sketchtool.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "0%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F7F7",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.8217916%",
    y1: "-6.21240556%",
    x2: "-9.03371699%",
    y2: "80.3250837%",
    id: "linearGradient-2"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFF",
    offset: "6%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D7FB",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "50%",
    x2: "30.145328%",
    y2: "73.6434364%",
    id: "linearGradient-3"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E65DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9FB9",
    offset: "40.6814487%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B8AB",
    offset: "70.6715137%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD19D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "65.9484812%",
    y1: "69.1234718%",
    x2: "31.5533715%",
    y2: "31.6324697%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F5FAFF",
    stopOpacity: 0,
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F7F8F8",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "90.8217916%",
    y1: "-6.21240556%",
    x2: "-3.43282586%",
    y2: "100%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E4F2FF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E1EFFF",
    offset: "10.9892248%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C7D7FB",
    offset: "65%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BDCEFA",
    offset: "89.1099169%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "83.2100818%",
    y1: "32.7907801%",
    x2: "0%",
    y2: "82.005801%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BE7C0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A89EB",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-1.11022302e-14%",
    y1: "50%",
    x2: "100%",
    y2: "50%",
    id: "linearGradient-7"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E65DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9FB9",
    offset: "40.6814487%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B8AB",
    offset: "70.6715137%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD19D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "50%",
    y1: "-2.48949813e-15%",
    x2: "50%",
    y2: "100%",
    id: "linearGradient-8"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2E65DB",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1D9FB9",
    offset: "40.6814487%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#15B8AB",
    offset: "70.6715137%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0FD19D",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "100%",
    y1: "100%",
    x2: "50%",
    y2: "10.6384807%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#2BE7C0",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#5A89EB",
    offset: "100%"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Homepage-MVP-EXTENDED",
    transform: "translate(-940.000000, -645.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "product-development",
    transform: "translate(857.000000, 568.000000)"
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "siatka-w-tle",
    transform: "translate(199.963682, 199.592429) scale(-1, 1) rotate(38.000000) translate(-199.963682, -199.592429) translate(57.598091, 57.656946)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Path-2",
    stroke: "#EDF1F3",
    opacity: 0.699999988,
    transform: "translate(142.313897, 141.930600) rotate(30.000000) translate(-142.313897, -141.930600) ",
    points: "38.2595761 169.372448 84.4904817 203.01507 110.697189 182.601324 144.34749 176.296966 151.599075 245.30978 160.317792 202.988255 110.681131 227.991603 50.7181366 210.594016 67.6605757 155.858914 105.178071 155.845647 144.359316 142.869015 137.394223 101.124722 186.788083 130.46292 246.368218 110.266438 233.314744 54.3202594 198.629133 71.1561373 151.672222 38.5514207 151.658951 76.0634007 186.805733 80.5735532 207.585643 105.058627"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-9",
    fill: "#EDF1F3",
    cx: 70.7610147,
    cy: 117.12725,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-50",
    fill: "#EDF1F3",
    cx: 38.7182911,
    cy: 113.391984,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-52",
    fill: "#EDF1F3",
    cx: 62.2162884,
    cy: 165.685699,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-58",
    fill: "#EDF1F3",
    cx: 29.105474,
    cy: 155.013513,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-65",
    fill: "#EDF1F3",
    cx: 70.7610147,
    cy: 200.903916,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-71",
    fill: "#EDF1F3",
    cx: 99.0654206,
    cy: 235.054913,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-72",
    fill: "#EDF1F3",
    cx: 248.064085,
    cy: 165.685699,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-73",
    fill: "#EDF1F3",
    cx: 264.619493,
    cy: 111.791156,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-74",
    fill: "#EDF1F3",
    cx: 226.70227,
    cy: 108.055891,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-77",
    fill: "#EDF1F3",
    cx: 211.214953,
    cy: 111.791156,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-75",
    fill: "#EDF1F3",
    cx: 201.602136,
    cy: 57.3630039,
    rx: 1.86915888,
    ry: 1.86763268
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval-3-Copy-76",
    fill: "#EDF1F3",
    cx: 183.444593,
    cy: 89.3795641,
    rx: 1.86915888,
    ry: 1.86763268
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "shape",
    transform: "translate(130.752688, 227.096774)",
    fillRule: "nonzero",
    stroke: "#0DD29F",
    strokeWidth: 5
  }, /*#__PURE__*/React.createElement("path", {
    d: "M126.457116,42.9686861 L60.1644153,4.38395947 C55.5074836,1.67345838 49.7545399,1.6690151 45.0934268,4.37231941 L7.44527045,26.2071089 C5.05652136,27.592511 4.24314789,30.652065 5.62854996,33.0408141 C6.06431709,33.792176 6.68829946,34.4170594 7.43903177,34.8539103 L73.7336038,73.4307008 C78.3896144,76.140032 84.1409051,76.1446315 88.8012433,73.4427511 L126.449761,51.6156242 C128.838727,50.2305959 129.652579,47.1711692 128.267551,44.7822034 C127.831855,44.030693 127.207884,43.40566 126.457116,42.9686861 Z",
    id: "Shape-Copy-8",
    transform: "translate(66.948088, 38.906296) scale(-1, 1) translate(-66.948088, -38.906296) "
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "podkladka",
    transform: "translate(104.946237, 172.043011)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M192.792707,49.7790522 L87.7037868,110.396575 C82.971108,113.134209 74.6196353,112.787336 69.1514727,109.628116 L5.05778401,72.7100757 C-0.410378682,69.5508562 -1.00729313,64.7052967 3.72538569,61.9836718 L110.626367,2.27869375 C115.359046,-0.458940661 123.710519,-0.112066906 129.178682,3.04715253 L191.460309,39.0526483 C196.928471,42.2172043 197.525386,47.0414178 192.792707,49.7790522 Z",
    id: "Shape",
    fill: "url(#linearGradient-1)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M195.889201,46.8209796 C196.267602,48.85953 195.260309,50.8607247 192.787377,52.2909119 L87.6984572,112.913771 C85.4227209,114.226555 82.2889201,114.813572 79.0911641,114.733524 L79.0911641,112.216328 C82.315568,112.296376 85.4280505,111.714695 87.7037868,110.396575 L192.787377,49.7790522 C194.578121,48.7437674 195.601403,47.4149741 195.89453,45.9847869 L195.889201,46.8209796 Z M69.1514727,109.62278 C72.203675,111.281689 75.6132557,112.171823 79.0858345,112.216328 L79.0805049,114.733524 C75.6079261,114.689019 72.1983454,113.798885 69.1461431,112.139976 L5.05778401,75.2326084 C1.65217391,73.2580963 0.138569425,70.6485383 0.618232819,68.2951333 L0.623562412,67.4589407 C0.964656381,69.3160494 2.4516129,71.2051772 5.05778401,72.7100757 L69.1514727,109.62278 Z",
    id: "Combined-Shape",
    fill: "#E2E7ED"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "bg",
    transform: "translate(128.172043, 77.419355)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "chart",
    transform: "translate(60.220846, 100.112647)"
  }, _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    id: "Group-98",
    transform: "translate(0.000000, 35.678443)",
    fill: "#CDDCFB"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-76",
    points: "92.6761522 13.688807 93.4936635 14.0967127 44.0764672 42.3921678 4.66205279 22.2755965 5.4795641 21.8671582 0.35119945 20.3883666 3.31161363 22.9502919 4.12912494 22.5418536 44.0764672 42.9241493 94.0265914 14.3629698 94.8441027 14.7714081 97.8045169 12.2100154"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-77",
    points: "19.5933844 25.9152314 19.8332019 25.4402289 48.2820671 39.8026919 48.0411837 40.2782269"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-78",
    points: "33.2589609 22.2612186 33.4971797 21.7846185 57.8287984 34.2507295 57.5905796 34.726797"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-79",
    points: "44.5383788 18.0154839 44.7771304 17.5394163 67.0442974 29.0468736 66.8060786 29.5229412"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-80",
    points: "54.6762652 12.4166308 54.9144839 11.9405632 77.1264529 23.0551112 76.8877012 23.5311788"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-81",
    points: "87.0185902 17.7992832 53.0801463 0.880245776 53.318365 0.404178187 87.2568089 17.3226831 87.0185902 17.7992832"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group-95",
    transform: "translate(27.712248, 0.000000)"
  }, /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-90",
    fill: "#B8D0F6",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    points: "18.5825118 23.6750607 22.4702417 25.6107666 30.5232931 9.99309053 26.6348384 8.0566632 18.5825118 23.6750607"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-91",
    fill: "#B8D0F6",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    points: "34.6878897 0.17820326 38.5756197 2.11390912 30.5232931 9.99309053 26.6348384 8.0566632 34.6878897 0.17820326"
  }), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-92",
    fill: "url(#linearGradient-2)",
    fillRule: "nonzero",
    points: "4.0571675 63.870665 54.6817223 32.7944502 54.6817223 9.575359 46.628671 1.97466528 38.5756197 2.11390912 30.5232931 9.99309053 22.4702417 25.6107666 14.4164656 24.3027402 6.36413905 38.5893028 4.0571675 41.0944187"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-93",
    fill: "#ACC6EF",
    fillRule: "nonzero",
    points: "4.14535115 41.2766965 4.14535115 63.8645009 0.257621202 61.928795 0.257621202 39.3417121"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-94",
    fill: "#ACC6EF",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    points: "3.97896687 41.2188255 6.36413905 38.5893028 2.47640911 36.6543184 0.091236927 39.2838411"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-95",
    fill: "#B8D0F6",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    points: "10.5294605 22.3670343 14.4164656 24.3027402 6.36413905 38.5893028 2.47640911 36.6543184 10.5294605 22.3670343"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-96",
    fill: "#B8D0F6",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    points: "10.5294605 22.3670343 14.4164656 24.3027402 22.4702417 25.611488 18.5825118 23.6750607 10.5294605 22.3670343"
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-97",
    fill: "#B8D0F6",
    fillRule: "nonzero",
    style: {
      mixBlendMode: "multiply"
    },
    points: "34.6878897 0.17820326 38.5756197 2.11390912 46.628671 1.97466528 42.7416658 0.0389594173 34.6878897 0.17820326"
  }), _polyline2 || (_polyline2 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-98",
    fill: "#128EC7",
    points: "30.2457016 37.2199514 34.1334316 39.1549358 42.1850334 31.2771974 38.2980282 29.34077 30.2457016 37.2199514"
  })), _polyline3 || (_polyline3 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-99",
    fill: "#1180BF",
    points: "46.3510795 36.9421852 50.2380847 38.8771696 58.2918608 19.3888033 54.4041309 17.4530975 46.3510795 36.9421852"
  })), _polyline4 || (_polyline4 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-100",
    fill: "#128EC7",
    points: "62.4564574 5.70466875 66.3434626 7.64037461 58.2918608 19.3888033 54.4041309 17.4530975 62.4564574 5.70466875"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-101",
    fill: "url(#linearGradient-3)",
    points: "66.3434626 39.1549358 66.3434626 7.64037461 58.2918608 19.3888033 50.2380847 38.8771696 42.1850334 31.2771974 34.1334316 39.1549358 26.0803802 30.1062504 18.0266041 36.6550399 13.2329652 51.2466582 13.2329652 70.0406128"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-102",
    fill: "#0F70AD",
    points: "13.4281812 51.3012708 13.4281812 69.9821076 9.53972648 68.0464017 9.53972648 49.3662864"
  })), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-103",
    fill: "#1180BF",
    points: "13.4274585 51.4951558 18.0266041 36.6550399 14.1395989 34.7186126 9.53900373 49.5601714"
  })), _polyline5 || (_polyline5 = /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-104",
    fill: "#128EC7",
    points: "22.1926503 28.1719875 26.0803802 30.1062504 18.0266041 36.6550399 14.1395989 34.7186126 22.1926503 28.1719875"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.26303899,79.8771121 C0.56462065,79.8741799 -6.16506229e-06,79.3076109 0,78.6097286 L0,51.9094726 C0.00927856803,51.4691399 0.247616372,51.0654912 0.628854857,50.8444444 L32.7537453,32.3129544 C32.9444464,32.2012321 33.1615388,32.1424053 33.3826002,32.1425499 C34.0646463,32.1479829 34.6202708,32.6914135 34.6403099,33.3726575 L34.6403099,60.0782386 C34.6310313,60.5185713 34.3926935,60.92222 34.0114551,61.1432668 L1.89189385,79.7013825 C1.70171926,79.8149694 1.48459319,79.875644 1.26303899,79.8771121 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.2661091,118.644137 C23.7750828,118.641207 22.5670972,117.43416 22.5641649,115.944291 L22.5641649,58.8268305 C22.5656578,57.8648621 23.0792832,56.9763512 23.9124724,56.4944188 L92.6175301,16.8540707 C93.0246857,16.6148198 93.4881697,16.488012 93.9605083,16.4866359 C95.4453305,16.4895106 96.6507637,17.6868808 96.6624525,19.1705069 L96.6624525,76.3039427 C96.6609596,77.2659111 96.1473342,78.154422 95.314145,78.6363543 L26.6090873,118.276703 C26.2019317,118.515953 25.7384477,118.642761 25.2661091,118.644137 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M79.4062489,42.3242192 C78.7893724,42.3213047 78.2900171,41.8223371 78.2871004,41.2059396 L78.2871004,17.5410138 C78.2812728,17.1466537 78.4837742,16.7783873 78.8200282,16.5718382 L107.289034,0.154429083 C107.450607,0.0584222966 107.634053,0.00526434953 107.821962,0 C108.438838,0.00291445781 108.938193,0.501882061 108.94111,1.11827957 L108.94111,24.7832053 C108.946938,25.1775655 108.744436,25.5458318 108.408182,25.752381 L79.9391767,42.1751152 C79.7771917,42.2694758 79.5937195,42.3208081 79.4062489,42.3242192 Z",
    id: "Shape",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "laptop",
    transform: "translate(124.731183, 111.827957)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7"
  }, /*#__PURE__*/React.createElement("g", {
    id: "imac"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(46.881720, 65.376344) scale(-1, 1) translate(-46.881720, -65.376344) "
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M2.94947011,126.392198 L2.87418877,56.0531287 C2.87437395,54.7808473 4.40725395,51.8495014 5.51260471,51.2143851 L90.7128344,2.02316671 C91.639587,1.48263918 92.763163,1.39400449 93.7635934,1.78250379 L92.3330115,1.02613462 C91.1923169,0.165401688 89.6447097,0.072746362 88.4089655,0.791201773 L3.27009661,50.0197182 C2.16296545,50.6558557 0.602920503,53.9100095 0.604791765,55.184338 L0.993564244,126.494887 C0.99044032,127.630922 1.53840062,128.698318 2.46436332,129.359922 C2.73606789,129.527453 2.99261299,129.665966 3.26296125,129.772487 L4.86015712,130.637727 C3.88207892,129.987494 2.95151855,127.564533 2.94947011,126.392198 Z",
    id: "Shape",
    fill: "url(#linearGradient-5)",
    transform: "translate(47.184192, 65.473918) scale(-1, 1) translate(-47.184192, -65.473918) "
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2212751,75.6423695 L91.4908779,121.879741 L91.4908779,128.277087 C91.4908779,128.360424 91.4908779,128.480527 91.4908779,128.522196 C91.4908779,128.563864 91.493336,128.585924 91.4908779,128.64475 C91.4884198,128.703577 91.4736712,128.762403 91.4736712,128.818778 C91.4655993,128.89295 91.4532887,128.966603 91.4367995,129.039376 C91.4367995,129.056534 91.4367995,129.076142 91.4367995,129.090849 C91.4220508,129.154577 91.4048441,129.218306 91.3876373,129.277132 C91.3847199,129.290543 91.3806067,129.303668 91.3753467,129.316349 C91.362489,129.36458 91.3468959,129.412044 91.3286426,129.458512 C91.3188102,129.483023 91.3188102,129.483023 91.3016034,129.527143 C91.2843966,129.571263 91.2647318,129.612931 91.2450669,129.6546 C91.157209,129.844356 91.0384309,130.018287 90.893557,130.169329 C90.8640597,130.198742 90.8394786,130.225704 90.8075232,130.252666 C90.7947159,130.267766 90.7798177,130.280971 90.7632772,130.291883 C90.7337799,130.316394 90.7067406,130.340905 90.6747852,130.360514 C90.6574884,130.377468 90.6375691,130.391537 90.6157905,130.402182 C90.5913975,130.421271 90.5650278,130.437705 90.537131,130.451204 C90.5126351,130.468112 90.4862349,130.482097 90.4584715,130.492873 C90.4334377,130.510342 90.4061516,130.524358 90.3773538,130.534541 C90.3282779,130.558333 90.2773009,130.57801 90.224951,130.593367 C90.1654514,130.613636 90.1046889,130.630011 90.0430508,130.642389 C89.4998083,130.760041 88.8459509,130.632585 88.1404731,130.228155 L56.654534,112.090085 L55.7991115,111.599867 L36.4759038,100.469465 L36.3997023,100.425345 L3.38236024,81.4122365 C2.36961865,80.8313281 1.45765961,79.7871635 0.835757617,78.6106401 C0.320053327,77.6776801 0.0336277937,76.6360527 0,75.5712879 L0,69.1837461 L0.027039217,3.68325481 C0.027039217,3.62442864 0.027039217,3.56315138 0.027039217,3.50432521 C0.0639108766,2.49937811 0.452292357,1.82777931 1.06682002,1.49197991 C1.68134768,1.15618052 2.49744041,1.21745778 3.40202512,1.73708896 L88.1503056,50.5260452 C90.1454391,51.8256034 91.4012977,53.9943274 91.5326658,56.3669939 L91.5326658,121.879741 L11.2212751,75.6423695 Z",
    id: "Combined-Shape",
    fill: "#B8D0F6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M25.9216788,106.529531 C25.6539903,105.520165 26.0422912,104.354612 26.7639086,103.915698 C26.3264956,104.211202 26.0723948,104.710382 26.0913771,105.236883 C26.0983833,105.431208 26.1422263,105.619157 26.2177656,105.792209 C26.3667408,105.547955 26.5559438,105.346292 26.7761992,105.212325 C26.7885029,105.207363 26.8000786,105.200767 26.8106127,105.192717 L26.8696074,105.15595 L37.3632817,100.971939 L57.6254877,112.641581 L49.9488082,118.855095 C49.0215864,119.393941 47.9690119,119.681263 46.8958347,119.688466 C45.8513353,119.688809 44.8252813,119.414003 43.9215209,118.891861 L26.8745236,109.116912 C25.9423652,108.534468 25.7098176,107.439265 25.9216788,106.529531 Z",
    id: "Combined-Shape",
    fill: "#B8D0F6",
    style: {
      mixBlendMode: "multiply"
    }
  }), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M55.8138601,111.594965 L49.9291433,116.291254 C48.044656,117.37674 45.7224324,117.37674 43.8379451,116.291254 L26.8573168,106.516305 C26.3997525,106.252885 26.1103595,105.773188 26.0913771,105.246687 C26.0723948,104.720186 26.3264956,104.221007 26.7639086,103.925503 C26.7762124,103.92054 26.787788,103.913944 26.7983222,103.905894 L26.8573168,103.869128 L36.3997023,100.437601 L36.4759038,100.481721 L55.8138601,111.594965 Z",
    id: "Shape",
    fill: "url(#linearGradient-2)"
  })), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    id: "Shape",
    fill: "#FFFFFF",
    points: "88.1748867 116.100069 88.1748867 54.4085726 3.33811425 5.5681434 3.33811425 67.25964"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "Group-11",
    transform: "translate(15.537942, 22.948431)"
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M66.9738863,5.01229801 L66.9738863,2.45674288 C66.9738863,0.264013487 65.3733633,-0.627275801 63.4767435,0.469088898 L3.45712975,34.6062574 C1.39989202,35.945882 0.115354852,38.1732134 0,40.6007694 L0,43.1247744 L66.9738863,5.01229801 Z",
    id: "Shape",
    fill: "#E9EFF4"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M6.6370518,36.344588 C6.56674098,37.3195711 6.0079349,38.2068729 5.12863094,38.7397383 C4.27157363,39.186833 3.62021007,38.8275604 3.62021007,37.9413548 C3.69052089,36.9663718 4.24932697,36.07907 5.12863094,35.5462046 C5.95997652,35.0671746 6.6370518,35.4503986 6.6370518,36.344588 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4639986,33.3314269 C11.3936877,34.3133376 10.8348817,35.206944 9.9555777,35.7435955 C9.09852039,36.193867 8.44715683,35.8320417 8.44715683,34.9395393 C8.51746765,33.9576286 9.07627373,33.0640222 9.9555777,32.5273706 C10.7954939,32.0931803 11.4639986,32.4550056 11.4639986,33.3314269 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2909453,30.3499686 C16.2219622,31.3272424 15.6628328,32.2167963 14.7825245,32.7498096 C13.9254672,33.1977799 13.2741036,32.8378037 13.2741036,31.9498626 C13.3444144,30.9729701 13.9032205,30.0839306 14.7825245,29.5500217 C15.6224406,29.0860524 16.2909453,29.454028 16.2909453,30.3499686 Z",
    id: "Shape",
    fill: "#FFFFFF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M64.6614069,38.8307764 L2.29647615,74.5968878 C1.03221402,75.3281061 0,74.5333036 0,72.8642184 L0,61.3634266 C0.031319262,59.6290666 0.885686517,58.0113456 2.30447781,56.999961 L64.6694085,21.2338496 C65.9336707,20.5105793 66.9738863,21.2894858 66.9738863,22.958571 L66.9738863,34.4593628 C66.9432186,36.1979638 66.0854625,37.8194298 64.6614069,38.8307764 Z",
    id: "Shape",
    fill: "#E9EFF4"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M27.1515755,57.710064 L19.307787,62.2913409 L19.307787,52.4976929 L27.1515755,47.916416 L27.1515755,57.710064 Z M37.4088374,52.1963819 L29.5650489,56.9007441 L29.5650489,48.4280918 L37.4088374,43.7237296 L37.4088374,52.1963819 Z M47.0627309,46.2801704 L39.2189424,50.911192 L39.2189424,38.7636056 L47.0627309,34.1404464 L47.0627309,46.2801704 Z M62.1469396,36.5362672 L62.1469396,34.6927677 L64.5604129,33.5414912 L64.5604129,35.3849908 L62.1469396,36.5362672 Z M62.1469396,32.3435808 L62.1469396,30.5000812 L64.5604129,29.3488048 L64.5604129,31.1923044 L62.1469396,32.3435808 Z M62.1469396,28.7498496 L62.1469396,26.90635 L64.5604129,25.7550736 L64.5604129,27.5985732 L62.1469396,28.7498496 Z M50.0795727,43.7237296 L50.0795727,41.7350418 L61.5435712,35.3383568 L61.5435712,37.3192152 L50.0795727,43.7237296 Z M50.0795727,39.5310432 L50.0795727,37.5501849 L61.5435712,31.1456704 L61.5435712,33.1343583 L50.0795727,39.5310432 Z M50.0795727,35.937312 L50.0795727,33.9564537 L61.5435712,27.5519392 L61.5435712,29.5406271 L50.0795727,35.937312 Z M4.82694676,59.8955201 L4.82694676,61.741814 L2.41347338,62.8902961 L2.41347338,61.0440021 L4.82694676,59.8955201 Z M4.82694676,63.4892513 L4.82694676,65.3355452 L2.41347338,66.4840273 L2.41347338,64.6377333 L4.82694676,63.4892513 Z M4.82694676,67.6819377 L4.82694676,69.5282316 L2.41347338,70.6767137 L2.41347338,68.8304197 L4.82694676,67.6819377 Z M16.8943137,52.7080576 L16.8943137,54.6907673 L5.43031511,61.0934305 L5.43031511,59.1107208 L16.8943137,52.7080576 Z M16.8943137,56.9007441 L16.8943137,58.8816024 L5.43031511,65.2861169 L5.43031511,63.297429 L16.8943137,56.9007441 Z M16.8943137,60.4944753 L16.8943137,62.4771849 L5.43031511,68.8798481 L5.43031511,66.8971384 L16.8943137,60.4944753 Z",
    id: "Combined-Shape",
    fill: "#FFFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M61.8183734,50.278055 L5.1555129,83.001082 C3.97884623,83.6770133 3.01684173,82.9533692 3.01684173,81.4106554 C3.04360273,79.786631 3.83666943,78.2709338 5.1555129,77.3232591 L61.8183734,44.5763757 C62.9950401,43.9004444 63.9570446,44.6240885 63.9570446,46.1668023 C63.937804,47.7992748 63.1439117,49.3254055 61.8183734,50.278055 Z",
    id: "Shape",
    fill: "#FFFFFF",
    style: {
      mixBlendMode: "overlay"
    }
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    id: "Group-13",
    transform: "translate(23.399724, 69.478043) scale(-1, 1) rotate(-120.000000) translate(-23.399724, -69.478043) translate(14.367466, 61.736107)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_114",
    fill: "url(#linearGradient-6)",
    points: "11.7365962 0.184531659 17.4799072 3.48229098 6.30495154 9.88699192 0.561640558 6.5892326"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_115",
    fill: "url(#linearGradient-7)",
    points: "6.33636824 9.8389708 17.4799072 3.48229098 17.4799072 8.94680914 6.33636824 15.303489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_116",
    fill: "#356ADB",
    points: "0.496589424 12.0030442 6.35300429 15.310175 6.35300429 9.84565689 0.496589424 6.54447869"
  })))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy",
    transform: "translate(42.152412, 58.804354) scale(-1, 1) rotate(-120.000000) translate(-42.152412, -58.804354) translate(33.120154, 51.062418)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_114",
    fill: "url(#linearGradient-6)",
    points: "11.7365962 0.184531659 17.4799072 3.48229098 6.30495154 9.88699192 0.561640558 6.5892326"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_115",
    fill: "url(#linearGradient-7)",
    points: "6.33636824 9.8389708 17.4799072 3.48229098 17.4799072 8.94680914 6.33636824 15.303489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_116",
    fill: "#356ADB",
    points: "0.496589424 12.0030442 6.35300429 15.310175 6.35300429 9.84565689 0.496589424 6.54447869"
  })))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    id: "Group-13-Copy-2",
    transform: "translate(59.297727, 49.198034) scale(-1, 1) rotate(-120.000000) translate(-59.297727, -49.198034) translate(50.265469, 41.456098)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-9"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_114",
    fill: "url(#linearGradient-6)",
    points: "11.7365962 0.184531659 17.4799072 3.48229098 6.30495154 9.88699192 0.561640558 6.5892326"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_115",
    fill: "url(#linearGradient-7)",
    points: "6.33636824 9.8389708 17.4799072 3.48229098 17.4799072 8.94680914 6.33636824 15.303489"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "_\\u015Bcie\\u017Cka_116",
    fill: "#356ADB",
    points: "0.496589424 12.0030442 6.35300429 15.310175 6.35300429 9.84565689 0.496589424 6.54447869"
  }))))), /*#__PURE__*/React.createElement("g", {
    id: "circle-chart",
    transform: "translate(161.720430, 247.741935)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M19.1354839,0.647276573 L19.1354839,4.50893707 L20.5505212,9.89040439 L21.0294933,10.3108286 L21.0294933,11.2953669 L21.8051613,14.661872 L41.5243011,17.9498678 C42.2907527,16.8346906 42.6563441,15.6674775 42.6202151,14.5028027 L42.6227957,10.6872554 L19.1354839,0.647276573 Z",
    id: "Fill-39",
    fill: "#B8D0F6",
    style: {
      mixBlendMode: "multiply"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.5243011,17.9498678 C42.2907527,16.8346906 42.6563441,15.6674775 42.6202151,14.5028027 L42.6227957,10.6872554 L41.5243011,14.0882073 L41.5243011,17.9498678",
    id: "Fill-40",
    fill: "#D9E8FE",
    opacity: 0.322265625,
    style: {
      mixBlendMode: "multiply"
    }
  }), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M0.387956375,11.3523004 C0.387956375,11.3523004 0.389247312,12.5939714 0.387956989,15.2135378 C0.386666667,17.8352195 2.41935484,20.4569011 6.48645161,22.4571126 C14.6176344,26.4558435 27.8008602,26.4558435 35.9316129,22.4571126 C38.2722581,21.3059757 39.9354839,19.9483871 40.928172,18.5040719 L40.928172,14.6424114 L0.387956375,11.3523004",
    id: "Fill-41",
    fill: "url(#linearGradient-8)"
  })), /*#__PURE__*/React.createElement("polyline", {
    id: "Fill-42",
    fill: "#B8D0F6",
    style: {
      mixBlendMode: "multiply"
    },
    points: "21.0197849 10.295505 10 1.60846113 10 5.47012163 21.0197849 14.1571655 21.0197849 10.295505"
  }), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1892473,2.66779482 C8.8744086,3.07181386 7.62924731,3.55198308 6.48645161,4.11380222 C-1.64473118,8.11295611 -1.64473118,14.5962983 6.48645161,18.5954521 C14.6176344,22.594183 27.8008602,22.594183 35.9316129,18.5954521 C38.2722581,17.4438921 39.9354839,16.0863035 40.928172,14.6424114 L21.2090323,11.3544157 L10.1892473,2.66779482",
    id: "Fill-43",
    fill: "url(#linearGradient-9)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M18.3509677,0.142147012 C15.4313978,0.326599683 12.5784946,0.81607615 10,1.60846113 L21.0197849,10.295505 L18.3509677,0.142147012",
    id: "Fill-44",
    fill: "url(#linearGradient-2)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M36.5277419,3.56002115 C31.7819355,1.22559492 25.3152688,0.25637229 19.1354839,0.647276573 L21.8051613,10.8002115 L41.5243011,14.0882073 C43.9810753,10.5146483 42.3182796,6.40761502 36.5277419,3.56002115",
    id: "Fill-45",
    fill: "url(#linearGradient-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUix);
export default __webpack_public_path__ + "static/media/uix.a8047cf5ef6bd0fab4b111a8ecc09b3d.svg";
export { ForwardRef as ReactComponent };